import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
    textAlign: 'center',
    color: "#FFF",
  },
}));

function TitleService(props) {
  const classes = useStyles();
  const { service } = props;

  return (
    <div className={classes.root}>
      <Fade in={true} timeout={1500}>
        <Typography variant="h2" align="center" gutterBottom className={classes.title}>
          {service}
        </Typography>
      </Fade>
    </div>
  );
}

export default TitleService;